import { Injectable, OnDestroy } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { HubConnectionState } from '@microsoft/signalr';
import { Store } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { PendingTransactionConfirmedDeletedWebSocketHandlerName } from '../constants/websocket.constants';
import { IPendingTransaction } from '../interfaces/pending-transaction.interface';
import { AuthState } from '../states/auth/auth.state';
import { AddPendingTransaction, DeletePendingTransactionFromView, UpdatePendingTransaction } from '../states/transactions/transactions.actions';
import { TransactionsService } from './transactions.service';
import { PharmacyState } from '../states/pharmacy/pharmacy.state';
@Injectable({
  providedIn: 'root'
})
export class PendingTransactionsHubService implements OnDestroy {
  interval: any;
  constructor(private store: Store, private transactionsService: TransactionsService) {}

   public startListening() {
    this.startConnection();
    this.addLibertyRxWebhookProcessedListener();
    this.hubConnection?.onclose(error => {
      console.log(`Connection closed: ${error}`);
      setTimeout(() => {
       this.startConnection();
       this.addLibertyRxWebhookProcessedListener();
      });
    });

    this.interval = setInterval(() => {
      if(this.hubConnection?.state === HubConnectionState.Disconnected || this.hubConnection?.state === HubConnectionState.Disconnecting) {
        setTimeout(() => {
          this.startConnection();
          this.addLibertyRxWebhookProcessedListener();
        });
      }
    }, 60000);
   }

  private hubConnection: signalR.HubConnection;

    public startConnection = () => {
      const signalRApiHost = environment.signalRApiHost;
      this.hubConnection = new signalR.HubConnectionBuilder()
                              .withUrl(`${signalRApiHost}/pendingTransactions?pharmacyId=${this.store.selectSnapshot(PharmacyState.currentPharmacy)?.id}`, {
                                skipNegotiation: true,
                                transport: signalR.HttpTransportType.WebSockets,
                                withCredentials: true,
                                accessTokenFactory: () => this.store.selectSnapshot(AuthState.bearerToken)
                              })
                              .withAutomaticReconnect([0, 2000, 5000, 10000])
                              .build();
           
      this.hubConnection
        .start()
        .then(() => console.log('Connection started'))
        .catch(err => console.log('Error while starting connection: ' + err));
    }
    
    private addLibertyRxWebhookProcessedListener = () => {
        this.hubConnection.on('ReceiveCreatedPendingTransaction', (pendingTransaction: IPendingTransaction) => {
            if (pendingTransaction) {
                this.store.dispatch(new AddPendingTransaction(pendingTransaction));
                this.transactionsService.pendingTransactionModified$.next(pendingTransaction.id);
            }
        });

        this.hubConnection.on('ReceiveUpdatedPendingTransaction', (pendingTransaction: IPendingTransaction) => {
            if (pendingTransaction) {
                this.store.dispatch(new UpdatePendingTransaction(pendingTransaction));
                this.transactionsService.pendingTransactionModified$.next(pendingTransaction.id);
            }
        });

        this.hubConnection.on('ReceiveDeletedPendingTransaction', (id: number) => {
            this.store.dispatch(new DeletePendingTransactionFromView(id));
            this.transactionsService.pendingTransactionModified$.next(id);
        });

        this.hubConnection.on(PendingTransactionConfirmedDeletedWebSocketHandlerName, (id: number) => {
          this.store.dispatch(new DeletePendingTransactionFromView(id));
          this.transactionsService.pendingTransactionModified$.next(id);
        });

    }

  public getState() {
    return this.hubConnection?.state;
   }

   ngOnDestroy(): void {
    clearInterval(this.interval);
    this.hubConnection?.stop(); 
   }
}
